module.exports = __webpack_public_path__ + "assets/edit-yellow-circle.7f1d1476.svg";